
// Show-When options for Contact custom fields (MAI-1751).
// Values are wire-stable identifiers used as Entity._id in CustomFieldMapping.contactTypes
// and matched at runtime by the EF reactive transformer + `<custom-field-section [contactType]>`.
// Renaming any value breaks stored mappings — keep stable.

import { ContactType } from '../contact/contact.type';
import { CustomerAccountTypes } from '../contact/contact';

export enum CustomFieldContactScope {
    BasicContact = 'BasicContact',
    Client = 'Client',
    Subcontractor = 'Subcontractor',
}

// Map a LoginContact parent account's type to its contact-field visibility scope.
// Single source of truth — used by both the EF reactive transformer (details page)
// and the LoginContact creator dialog. Keep behavior aligned.
//
// Accepts null/undefined directly so callers can pass `signal()?.type` or `parent?.type`
// without defensive guards — both flow to the `return null` fall-through.
//
// Rules:
//   Subcontractor parent       → Subcontractor scope (UI: Contractor)
//   CustomerAccountTypes       → Client scope (ServiceProvider, Business, Individual)
//   Supplier, WorkBuddyCompany → null (no scope; only unscoped fields visible)
//   null / undefined / unknown → null
//
// Returning null is intentional — no binary default. A LoginContact under a parent
// type outside this map sees only custom fields with empty contactTypes.
export function getCustomFieldContactScopeFromParentType(t: ContactType | null | undefined): CustomFieldContactScope | null {
    if (t === ContactType.Subcontractor) return CustomFieldContactScope.Subcontractor;
    if (t && CustomerAccountTypes.includes(t)) return CustomFieldContactScope.Client;
    return null;
}
